/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ChangeTimezoneData {
    getFixupPrototypeFunction() { return ChangeTimezoneData.fixupPrototype; }

    static newInstance(model: Partial<ChangeTimezoneData>): ChangeTimezoneData {
        let obj = Object.assign(new ChangeTimezoneData(), model);
        ChangeTimezoneData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ChangeTimezoneData>): ChangeTimezoneData {
        if (!model) return null;
        return ChangeTimezoneData.newInstance(<ChangeTimezoneData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ChangeTimezoneData) {
        if (!obj) return;

        models.ChangeTimezoneData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ChangeTimezoneData): boolean {
        Object.setPrototypeOf(obj, ChangeTimezoneData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Raw offset of the timezone. It means the amount of time in milliseconds to add to UTC to get standard time in the required time zone
     */
    raw_offset: string;

    /**
     * ID of the Timezone such as Asia/Kolkata, Asia/Dubai and so on
     */
    id: string;

}
